import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { getUninstallableReason } from '../utils/installability';
function getAppInstallability({
  offeringId
}) {
  return http.get(`ecosystem/v1/apps/${offeringId}/installability`);
}
const GET_APP_INSTALLABILITY = registerQuery({
  fieldName: 'appInstallability',
  args: ['offeringId'],
  fetcher: getAppInstallability
});
export function useAppInstallability({
  appContext = 'app',
  // default to app context
  offeringId
}) {
  const {
    data: installabilityData,
    loading: installabilityLoading,
    error: installabilityError,
    refetch: installabilityRefetch
  } = useQuery(GET_APP_INSTALLABILITY, {
    variables: {
      offeringId
    },
    skip: appContext !== 'app' || !offeringId
  });
  const installability = installabilityData === null || installabilityData === void 0 ? void 0 : installabilityData.appInstallability;
  const uninstallableReason = installability && getUninstallableReason(installability);
  return {
    installability,
    installabilityError,
    installabilityLoading,
    installabilityRefetch,
    uninstallableReason
  };
}